import React, { useEffect, useState } from "react";
import { useGoogleContext } from "../../../context/GoogleContext";
import { NewsIcon } from "../../../utils/utils";

const NewsTicker = ({ query = null } = {}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { googleNews, fetchGoogleNewsFeedData } = useGoogleContext();

  const headlineElements = googleNews?.map((item, index) => (
    <a
      key={index}
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      className="headline-item"
      aria-label={`News update: ${item.title}`}
      style={{ color: "inherit", textDecoration: "none" }}
    >
      <NewsIcon />
      {item.title}
    </a>
  ));

  const scrollDuration = 1500;

  useEffect(() => {
    fetchGoogleNewsFeedData(query);
  }, [fetchGoogleNewsFeedData, query]);

  return (
    <>
      <div
        className="news-ticker"
        role="marquee"
        aria-live="polite"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <span className="ticker-label">{query}:</span>

        <div className="ticker-window">
          <div
            className={`ticker-content${isHovered ? " paused" : ""}`}
            aria-hidden="true"
          >
            <div className="ticker-text">{headlineElements}</div>
            <div className="ticker-text">{headlineElements}</div>
          </div>
        </div>
      </div>

      <style>{`
        .news-ticker {
          top: 20px;
          left: 20px;
          width: 100%;
          height: 2.5rem;
          background-color: #222;
          color: #fff;
          box-sizing: border-box;
          padding: 0.5rem 1rem;
          font-weight: bold;
          font-size: 1rem;
          line-height: 1.5rem;
          z-index: 1000;
          display: flex;
          align-items: center;
          user-select: none;
          cursor: default;
          gap: 1rem;
          overflow: hidden;
        }
        .ticker-label {
          width: 80px;
          white-space: nowrap;
          color: #ffd700;
          font-weight: 700;
        }

        .ticker-window {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          min-width: 0;
        }
        .ticker-content {
          display: inline-flex;
          animation: scroll-left ${scrollDuration}s linear infinite;
          will-change: transform;
        }
        .ticker-content.paused {
          animation-play-state: paused;
        }
        .ticker-text {
          display: inline-flex;
          gap: 4rem; /* spacing between headlines */
        }
        .headline-item {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          margin-right: 2rem;
        }
        .headline-item:hover {
          text-decoration: underline;
        }
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </>
  );
};

export default NewsTicker;
